import { render } from "./CaseView.vue?vue&type=template&id=171d9f9e&scoped=true&ts=true"
import script from "./CaseView.vue?vue&type=script&lang=ts"
export * from "./CaseView.vue?vue&type=script&lang=ts"

import "./CaseView.vue?vue&type=style&index=0&id=171d9f9e&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171d9f9e"]])

export default __exports__